var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tech-evaluation-platform"},[_c('lunbo'),_c('section',{staticClass:"intro-section"},[_c('div',{staticClass:"container"},[_c('PingJia'),_c('div',{staticClass:"apply-cta",on:{"click":_vm.toRegister}},[_c('a',{staticClass:"apply-btn",attrs:{"href":"#"}},[_vm._v("评 价 申 请 入 口")])])],1)]),_c('pingjiaBaogao'),_c('liuCheng')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }